import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';

export const HealthCoinsurance = () => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="HealthCoinsurance"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          label="Coinsurance"
          decimalScale={2}
          allowNegative={false}
          rightIcon="far fa-percent"
          onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
        />
      )}
    />
  );
};
